import React from 'react';

const fmt = (n) => '£' + Number(n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export default function StatsBar({ summary, postedCount, mode = 'xero' }) {
  if (!summary) return null;
  const codedCount = summary.codedMatches || 0;

  return (
    <div className="stats-bar">
      <div className="stat-card">
        <div className="stat-label">Total transactions</div>
        <div className="stat-value" style={{ color: '#2E92B6' }}>{summary.totalTransactions}</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Confident matches</div>
        <div className="stat-value" style={{ color: '#4935A8' }}>{summary.exactMatches}</div>
      </div>
      {codedCount > 0 && (
        <div className="stat-card">
          <div className="stat-label">Auto-coded by rules</div>
        <div className="stat-value" style={{ color: '#2E92B6' }}>{codedCount}</div>
        </div>
      )}
      {summary.ignoredMatches > 0 && (
        <div className="stat-card">
          <div className="stat-label">Ignored by rules</div>
          <div className="stat-value" style={{ color: '#888' }}>{summary.ignoredMatches}</div>
        </div>
      )}
      <div className="stat-card">
        <div className="stat-label">Needs review</div>
        <div className="stat-value" style={{ color: '#BA7517' }}>{summary.partialMatches}</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Unmatched</div>
        <div className="stat-value" style={{ color: '#A32D2D' }}>{summary.unmatched}</div>
      </div>
      {mode === 'xero' && (
        <div className="stat-card">
          <div className="stat-label">Posted to Xero</div>
        <div className="stat-value" style={{ color: '#4935A8' }}>{postedCount}</div>
        </div>
      )}
      <div className="stat-card">
        <div className="stat-label">Value matched</div>
        <div className="stat-value" style={{ color: '#4935A8', fontSize: '16px' }}>{fmt(summary.totalValueMatched)}</div>
      </div>
    </div>
  );
}
